import { aliyunImageThumb, aliyunImageInfo } from "./aliyun";
import { ysImageThumb, ysImageInfo } from "./ys";
/**
 * 图片缩略图
 */
export function imageThumb(
  url,
  options = {
    //缩放 resize 参数
    l: null, //指定目标缩略图的最长边。 	1-4096
    s: null, //指定目标缩略图的最短边。 	1-4096
    w: null, //	指定目标缩略图的最长边。   1-4096
    h: null, //指定目标缩略图的高度。      1-4096
  },
  mode = "auto"
) {
  let thumbUrl;
  if (mode === "auto") {
    const patt = /^http(s?):\/\/.+aliyuncs.com\/.+/;
    if (patt.test(url)) {
      // 阿里oss地址
      thumbUrl = aliyunImageThumb(url, options);
    } else {
      thumbUrl = ysImageThumb(url, options);
    }
  } else {
    thumbUrl = ysImageThumb(url, options);
  }
  return thumbUrl;
}

/**
 * 图片信息 宽 高
 * @param {Object} url
 */
export async function imageInfo(url) {
  const [error, info] = await ysImageInfo(url);
  return info;
}
